import r from"immer";import{useState as n,useCallback as t,useMemo as o,useReducer as i}from"react";function u(o){var i=n(o),u=i[1];return[i[0],t(function(n){u(r(n))},[])]}function e(n,t,u){var e=o(function(){return r(n)},[n]);return i(e,t,u)}export{u as useImmer,e as useImmerReducer};
//# sourceMappingURL=use-immer.module.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/use-immer/dist/use-immer.module.js
// module id = 131
// module chunks = 1